export default __webpack_public_path__ + "static/media/hotel_3.e05adb14.webp";